import { DEFAULTS } from "./defaultSettings";
import { mentionConverter } from "./mention-converter";
import { tiptapExtensions } from "./tiptap/tiptap";
import { MENTION_TYPE } from "./types";
const pluginMentions = (config) => {
  const pluginConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    pmNodeConverters: [],
    pmMarkConverters: [mentionConverter],
    type: MENTION_TYPE,
    tiptapExtensions
  };
};
export {
  pluginMentions
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject";
injectCss();
